// Static imports for hero and above-the-fold components (critical for LCP)
import HeroV2 from '../../components/landing-pages-v2/HeroV2';
import HeroV2WithMarkers from '../../components/landing-pages-v2/HeroV2WithMarkers';
import { dynamicEntry } from './dynamicEntry';
import IEntryLookup from './entries';

// Dynamic imports for below-the-fold components only
const CarouselCards = dynamicEntry(
  () => import('../../components/landing-pages-v2/CarouselSection/CarouselCards'),
);
const ContactSection = dynamicEntry(
  () => import('../../components/landing-pages-v2/ContactSection'),
);
const LWCTextSection = dynamicEntry(
  () => import('../../components/landing-pages-v2/LWCTextSection'),
);
const MapBackgroundHero = dynamicEntry(
  () => import('../../components/landing-pages-v2/MapBackgroundHero'),
);
const LWCHeroCard = dynamicEntry(() => import('../../components/landing-pages-v2/LWCHeroCard'));
const LWCImageCard = dynamicEntry(() => import('../../components/landing-pages-v2/LWCImageCard'));
const Spacer = dynamicEntry(() => import('../../components/landing-pages-v2/Spacer'));
const StandaloneText = dynamicEntry(
  () => import('../../components/landing-pages-v2/StandaloneText'),
);
const FCHero = dynamicEntry(() => import('../../components/landing-pages-v2/FCHero'));
const FCTrustBanner = dynamicEntry(() => import('../../components/landing-pages-v2/FCTrustBanner'));
const FCValueTracker = dynamicEntry(
  () => import('../../components/landing-pages-v2/FCValueTracker'),
);
const FCThreeSteps = dynamicEntry(() => import('../../components/landing-pages-v2/FCThreeSteps'));
const FCProductOptions = dynamicEntry(
  () => import('../../components/landing-pages-v2/FCProductOptions'),
);
const FCTestimonialCarousel = dynamicEntry(
  () => import('../../components/landing-pages-v2/FCTestimonialCarousel'),
);
const FCMap = dynamicEntry(() => import('../../components/landing-pages-v2/FCMap'));
const FCMissionStatement = dynamicEntry(
  () => import('../../components/landing-pages-v2/FCMissionStatement'),
);
const FCContactUs = dynamicEntry(() => import('../../components/landing-pages-v2/FCContactUs'));
const TextBanner = dynamicEntry(() => import('../../components/landing-pages-v2/TextBanner'));

const homePageV2EntryLookup: IEntryLookup = {
  // only including blocks used in https://app.contentful.com/spaces/bjlp9d7o6h1o/entries/3jH3XGe228kfdp8fBGddyW?focusedField=slug
  // for performance
  block: {
    lpComponentMapBackgroundHero: MapBackgroundHero,
    lpComponentCarouselCards: CarouselCards,
    lpComponentContactSection: ContactSection,
    lpComponentLwcTextSection: LWCTextSection,
    lpComponentLwcHeroCard: LWCHeroCard,
    lpComponentLwcImageCard: LWCImageCard,
    lpComponentHeroV2: HeroV2,
    lpComponentHeroV2WithMarkers: HeroV2WithMarkers,
    lpComponentSpacer: Spacer,
    lpComponentStandaloneText: StandaloneText,
    fcHero: FCHero,
    fcTrustBanner: FCTrustBanner,
    fcValueTracker: FCValueTracker,
    fcThreeSteps: FCThreeSteps,
    fcProductOptions: FCProductOptions,
    fcTestimonialCarousel: FCTestimonialCarousel,
    fcMap: FCMap,
    fcMissionStatement: FCMissionStatement,
    fcContactUs: FCContactUs,
    lpComponentTextBanner: TextBanner,
  },
  inline: {},
};

export default homePageV2EntryLookup;
